import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";
import { IStatus } from "shared/types";

const {
  members: { membersTable: tableCopy },
} = copy;

export const getMembersActions = ({
  handleView,
  handleEdit,
  handleEditPermissions,
  handleDelete,
  canView,
  canManage,
}: {
  handleView: () => void;
  handleEdit: () => void;
  handleEditPermissions: () => void;
  handleDelete: () => void;
  canView: boolean;
  canManage: boolean;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [];

  if (canView) {
    actions.push({
      label: tableCopy.actions.view,
      handleClick: handleView,
      dataTestId: "view_member_action",
    });
  }

  if (canManage) {
    actions.push(
      {
        label: tableCopy.actions.edit,
        handleClick: handleEdit,
        dataTestId: "edit_member_action",
      },
      {
        label: tableCopy.actions.permissions,
        handleClick: handleEditPermissions,
        dataTestId: "edit_permission_action",
      },
      {
        label: tableCopy.actions.delete,
        handleClick: handleDelete,
        status: IStatus.error,
        dataTestId: "delete_member_action",
      }
    );
  }

  return actions;
};
